
namespace Gordic.Adm.WebControls {

    /**
     * AdmAuditPristupu (historie změn)
     * 
     * @author thazmuka
     * @since 484.1.0.0
     */
    export class AdmAuditPristupu {

        private panelElement: JQuery<HTMLElement>;
        private sxs: string;
        private typ_obj: number;
        private grid: JQuery<HTMLElement>;
        private gtable: JQuery<HTMLElement>;
        private bylRead: boolean = false;       // příznak, že data již byla jednou načtena
        private oneRead: boolean = true;        

        /**
         * vytvořit panel auditu přístupu (historie změn)
         * @param a_sxs ID objektu administrace
         * @param a_typ_obj Typ objektu administrace
         * @param a_one_read Příznak, že se má realizovat pouze jedno načtení - jinak se bude dělat při každém zobrazení tohoto sidebaru refresh dat ze serveru
         * @param sidebarElement
         */
        public create(a_sxs: string, a_typ_obj: number, a_one_read: boolean = true, sidebarElement?: JQuery<HTMLElement>): GSideBarPanelOptions {
            this.oneRead = a_one_read;
            this.sxs = a_sxs;
            this.typ_obj = a_typ_obj;

            if (sidebarElement == null) {
                this.panelElement = $("<div>");
            }
            else {
                this.panelElement = sidebarElement;
            }

            // toto zajistí pouze prvotní načtení, když se sidebar vytváří
            //this.getGridAudit();

            return {
                //customDiv: this.panelElement,
                leaf: {
                    caption: "jres:32000146",                   //RC 32000146 : Audit
                },
                icon: "gi-nahled",
                minWidth: 400,
                id: "panelAuditPristupu",
                caption: "jres:32000145",                       //RC 32000145 : Audit přístupů
                open: (ev, obj) => {
                    if (!(this.bylRead && this.oneRead)) {
                        this.bylRead = true;
                        this.panelElement = $(ev.target);
                        this.panelElement.empty();
                        // toto zajistí nové načtení vždy, když se sidebar zobrazí - tedy i opakovaně na stále stejném detail okně
                        this.getGridAudit();
                    }
                },
            };
        }

        private createGrid(format) {
            this.grid = $("<div>").appendTo(this.panelElement).gautofit({ parentElement: ".g-sbp-content" }).ggrid({
                columns: format,        // GGridColumn<TRow>[] | Gordic.Data.GridFormat<TRow>
                columnMode: "full",
                multi: false,
                sort: "!dat_zmena"
            });
        }

        private createGtable(format) {
            this.gtable = $("<div>").appendTo(this.panelElement).gautofit({ parentElement: ".g-sbp-content" }).gtable({
                columns: format,        // GGridColumn<TRow>[] | Gordic.Data.GridFormat<TRow>
            });
        }


        private server: GContent;

        //FCE PRO VYKRESLENÍ SEZNAM auditních dat obecného subjektu administrace
        private getGridAudit() {

            if (this.server === undefined) {
                this.server = new GContent("Gordic.Adm.WebControls.AdmSidebarsService",this.panelElement);
            }

            // Načtení seznamu změn zadaného objektu ( zadán podle svého ID a typu )
            Gordic.Isl.AdmObjektZmena.listWithMeta({
                filters: { sxs: this.sxs, typ_obj: this.typ_obj },
                fragments: []
            })
                .get()
                .done((response) => {
                    var obj = GAdmUtils.createGridFromResponseWithMeta(response);
                    //this.createGtable(obj.format);
                    //this.gtable.gtable("setData", obj.view)
                    this.createGrid(obj.format);
                    this.grid.ggrid("setData", obj.view, true);
            });

            // staré volání, ještě se používá na javascript straně, časem odstranit
            //this.server.call("GetSeznamGinhobj", { a_sxs: this.sxs, a_type: this.typ_obj })
            //    .then((data) => {
            //        var obj = GAdmUtils.createGrid(data);
            //        this.createGrid(obj.format);
            //        this.grid.ggrid("setData", obj.view, true);
            //    });
        }
    }

}

